export const SLICE_NAME = 'users';
